// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.Charge
import org.mifos.mobile.core.model.entity.Page

@OptIn(InternalKtorfitApi::class)
public class _ClientChargeServiceImpl(
  private val _ktorfit: Ktorfit,
) : ClientChargeService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun getClientChargeList(clientId: Long): Flow<Page<Charge>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "clients/${"$clientId".encodeURLPath()}/charges")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<Page<Charge>>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getChargeList(chargeType: String, chargeTypeId: Long): Flow<List<Charge>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "${"$chargeType".encodeURLPath()}/${"$chargeTypeId".encodeURLPath()}/charges")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<List<Charge>>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }
}

public class _ClientChargeServiceProvider : ClassProvider<ClientChargeService> {
  override fun create(_ktorfit: Ktorfit): ClientChargeService = _ClientChargeServiceImpl(_ktorfit)
}

public fun Ktorfit.createClientChargeService(): ClientChargeService = _ClientChargeServiceImpl(this)
